import React, { useEffect, useState } from 'react'
import System from "../../../../../helper/system";
import Helper from 'src/helper/Helper';
import { useOrderStore } from 'src/hooks/order';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import orderinsiteuser from "src/assets/images/order-insite-user.svg";
import orderinsitebilling from "src/assets/images/order-insite-billing.svg";
import orderinsiteshipping from "src/assets/images/order-insite-shipping.svg";
import orderinsiteshippingmethod from "src/assets/images/order-insite-shipping-method.svg";

const OrderInfoListing = () => {
    const [__check] = useAxiosIndicatorCheck();
    const { translation: t } = System;

    const { addressType: { BILL_TO, SHIP_TO }, siteUser: { CORE }, speedBoats: { apacAbbr, japanAbbr } } = Constants
    const [{ order_detail: { orderHeader } }, { fetch_order_detail, fetch_Order_Service_Rep_Email }, { order_download_invoice }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({
        monitorJs: false,
        frameworkReady: false
    })
    useEffect(() => {
        async function fetchHere() {
            await getOrderDetail()
            await fetch_Order_Service_Rep_Email();
        }

        fetchHere()
    }, []);

    const getOrderDetail = async () => {
        const { orderNumber: AzureOrderNumber = '' } = System.getParams();

        const res = await fetch_order_detail({ AzureOrderNumber: AzureOrderNumber })
        if (!monitorFunctionCall?.frameworkReady || !monitorFunctionCall?.monitorJs) {
            System.monitorFrameWorkReady()
            System.monitorJSDx()
            setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true, monitorJs: true })
        }
        if (Object.keys(res?.payload)?.length === 0) {
            system_alert_indicator({
                name: "orderDetailNotFound",
                message: t('sorryNoOrderResultFound'),
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true,
            });
        }
    }

    const downloadInvoice = async (invoiceNumber, orderNumber = 0) => {
        if (System.getCurrentRegionWithType(japanAbbr)) {
            System.popup('OrderJapanInvoicePopup', {
                orderNumber: orderNumber,
                invoiceNumber: invoiceNumber
            })
        } else {
            const result = await order_download_invoice(invoiceNumber);
            if (result) {
                system_alert_indicator({
                    name: 'DownloadOrder',
                    message: t('downloadMsg'),
                    type: "success"
                })
            }
        }
    }

    const renderAddress = (address, type, contactInfo) => {
        const addressType = type === BILL_TO ? "billTo" : "shipTo"

        if (address) {
            const getValue = (field) => Helper.valueIsNotNull(address?.[field]) ? address?.[field] : '';

            return (
                <div>
                    <p>
                        {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && getValue(`${addressType}HouseNum`)?.trim() && (
                            <>
                                {" "}{getValue(`${addressType}HouseNum`).trim()},{" "}
                            </>
                        )}
                        {getValue(`${addressType}Street1`)},
                        {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && getValue(`${addressType}HouseNumSuppl`)?.trim() && (
                            <>
                                {" "}{getValue(`${addressType}HouseNumSuppl`).trim()},
                                
                            </>
                        )}
                        <br />
                        {getValue(`${addressType}Street2`)?.trim() && (
                            <>
                                {" "}{getValue(`${addressType}Street2`).trim()},
                                <br />
                            </>
                        )}
                        {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && getValue(`${addressType}Street3`)?.trim() && (
                            <>
                                {" "}{getValue(`${addressType}Street3`).trim()},
                                <br />
                            </>
                        )}
                        {getValue(`${addressType}City`)}
                        {System.getCurrentRegionWithType(Constants.speedBoats.apacAbbr) && getValue(`${addressType}District`).trim() && `, ${getValue(`${addressType}District`).trim()}`}
                        {getValue(`${addressType}Region`).trim() && `, ${getValue(`${addressType}Region`).trim()}`}
                        {getValue(`${addressType}PostalCode`).trim() && " " + getValue(`${addressType}PostalCode`).trim()}<br />
                        {getValue(`${addressType}Country`).trim()}<br />
                        {t(`attentionTo`)}: {contactInfo?.contactName ? contactInfo?.contactName : "-"}<br />
                        {contactInfo?.contactTel}
                    </p>
                </div>
            );
        } else {
            return <></>;
        }
    };

    const displayTrackingNumber = (number, carrier) => {
        let carrierLink = ''

        if (carrier && System.getCurrentRegionWithType(japanAbbr)) {
            const carrierMethod = carrier?.split('|')[1] || ''
            carrierLink = carrierMethod !== '' ? System.getTrackingLink(carrierMethod) : ''
        }

        return carrierLink !== '' ? <a href={carrierLink} target='_blank'><p className='text-blue'>{number}</p></a> :
            <p className='text-black'>{number}</p>
    }

    const displayShippingMethod = (carrier) => {
        const carrierMethod = carrier?.split('|')[1] || ''
        const carrierCode = carrier?.split('|')[3] || ''

        return <div>{System.getCurrentRegionWithType(apacAbbr) && !carrierMethod?.includes('INCOTERM') && <div>{carrierMethod}<br /></div>}{carrierCode}</div>
    }

    return (
        <>
            {__check(['GET_ORDER_DETAIL']).render}
            {
                !__check(['GET_ORDER_DETAIL']).status &&
                orderHeader && Object.keys(orderHeader).length > 0 &&

                <div className="order-information-wrapper">
                    <div className="order-information container-fluid maxw100 ">
                        <h4 className="heading mt-3 mb-0 font-18 lh-sm">{t('orderInformation')}</h4>
                        <div className="bs5 row order-information-row">
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">{t('pONumber')} </strong></div>
                                <div className='font-13 font-arial'>{orderHeader?.poNumber && orderHeader?.poNumber.trim() !== '' ? orderHeader?.poNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">{t('webOrderNumber')}</strong></div>
                                <div className='font-13 font-arial'>{orderHeader?.webOrderNumber && orderHeader?.webOrderNumber.trim() !== '' ? orderHeader?.webOrderNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">{t('salesOrderNumber')}</strong></div>
                                <div className='font-13 font-arial'>{orderHeader?.salesOrderNumber && orderHeader?.salesOrderNumber.trim() !== '' ? orderHeader?.salesOrderNumber : '-'}</div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3">
                                <div className='font-13 font-arial'><strong className="text-black">{t('orderStatus')}</strong></div>
                                <div className='font-13 font-arial'>{orderHeader?.orderStatus && orderHeader?.orderStatus.trim() !== '' ? orderHeader?.orderStatus : '-'}</div>
                            </div>
                        </div>
                        <div className="bs5 row order-information-row bg-grey pb-2">
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsiteuser} className="me-2" /> {t('buyerContactInformation')}</div>
                                <div className="head-desc">
                                    <div className='font-13 font-arial'>{orderHeader?.buyerInformation?.userName && orderHeader?.buyerInformation?.userName.trim() !== '' ? orderHeader?.buyerInformation?.userName : '-'}</div>
                                    <div className='font-13 font-arial'>{orderHeader?.buyerInformation?.userEmail && orderHeader?.buyerInformation?.userEmail.trim() !== '' ? orderHeader?.buyerInformation?.userEmail : ''}</div>
                                    <div className='font-13 font-arial'>{orderHeader?.buyerInformation?.userContactNumber && orderHeader?.buyerInformation?.userContactNumber.trim() !== '' ? orderHeader?.buyerInformation?.userContactNumber : ''}</div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsitebilling} className="me-2" /> {t('billingAddress')}</div>
                                <div id="ord_details_billing">
                                    <div className="head-desc">
                                        {
                                            orderHeader?.billingAddress && Object.entries(orderHeader?.billingAddress).length > 0 &&
                                            <>
                                                <div className='font-13 font-arial'>{
                                                    orderHeader?.billingAddress.billToName1?.trim() +
                                                    (orderHeader?.billingAddress.billToName2?.trim() ? " " + orderHeader?.billingAddress.billToName2?.trim() : "") +
                                                    (orderHeader?.billingAddress.billToName3?.trim() ? " " + orderHeader?.billingAddress.billToName3?.trim() : "") +
                                                    (orderHeader?.billingAddress.billToName4?.trim() ? " " + orderHeader?.billingAddress.billToName4?.trim() : "")}</div>
                                                {renderAddress(orderHeader?.billingAddress, BILL_TO, orderHeader?.contactInfo)}
                                            </>
                                        }
                                    </div>
                                </div>
                                <p />
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"> <img src={orderinsiteshipping} className="me-2" /> {t('shippingAddress')}</div>
                                <div id="ordDetailShipAddr">
                                    <div className="field">
                                        <div className="head-desc">
                                            {
                                                orderHeader?.shippingAddress && Object.entries(orderHeader?.shippingAddress).length > 0 &&
                                                <>
                                                    <div className='font-13 font-arial'> {
                                                        orderHeader?.shippingAddress.shipToName1?.trim() +
                                                        (orderHeader?.shippingAddress.shipToName2?.trim() ? " " + orderHeader?.shippingAddress.shipToName2?.trim() : "") +
                                                        (orderHeader?.shippingAddress.shipToName3?.trim() ? " " + orderHeader?.shippingAddress.shipToName3?.trim() : "") +
                                                        (orderHeader?.shippingAddress.shipToName4?.trim() ? " " + orderHeader?.shippingAddress.shipToName4?.trim() : "")}</div>
                                                    {renderAddress(orderHeader?.shippingAddress, SHIP_TO, orderHeader?.contactInfo)}
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 ">
                                <div className="head"><img src={orderinsiteshippingmethod} className="me-2" /> {t('shippingMethod')}</div>
                                <div>
                                    <div className="head-desc">
                                        {orderHeader?.shippingMethod ? displayShippingMethod(orderHeader?.shippingMethod) : "-"}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bs5 row order-information-row p-0">
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">{t('invoice')}</div>
                                {orderHeader?.invoice && orderHeader?.invoice?.filter(item => item !== null)?.length > 0 ?
                                    <>
                                        {orderHeader.invoice?.filter((item, index, self) => self.indexOf(item) === index && item)?.length <= 2 ?
                                            orderHeader.invoice?.filter((item, index, self) => self.indexOf(item) === index && item)?.map((v, i) => {
                                                if (i < 2) {
                                                    return <div className="mb-2">
                                                        <i className="fa fa-download me-1" aria-hidden="true" />
                                                        <a href={void (0)} aria-label="InvoiceGenerationlink"
                                                            onClick={() => downloadInvoice([v], orderHeader?.webOrderNumber)}>{v} </a>
                                                        <input type="hidden" id="invoiceUrlGeneration1" />
                                                    </div>
                                                }
                                            }) :
                                            <div className="mb-2">
                                                <a href={void (0)} aria-label="InvoiceGenerationlink" data-toggle="modal" data-target="#ViewAllInvoices" onClick={() => {
                                                    System.popup('OrderDetailViewInvoicesPopup', {
                                                        invoiceData: orderHeader.invoice,
                                                        poNumber: orderHeader.poNumber,
                                                        orderNumber: orderHeader.webOrderNumber
                                                    });
                                                }}>{t('viewAllInvoices')} </a>
                                            </div>
                                        }
                                    </> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">{t('trackingWayBillNumber')} </div>
                                {orderHeader.trackingNumbers && orderHeader.trackingNumbers?.filter(item => item !== null)?.length > 0 ?
                                    <div id="tracking_55640725">
                                        {orderHeader.trackingNumbers?.filter((item, index, self) => self.indexOf(item) === index && item)?.length <= 2 ?
                                            orderHeader.trackingNumbers?.filter((item, index, self) => self.indexOf(item) === index && item)?.map((v, i) => {
                                                if (i < 2) {
                                                    return <div key={i}>{displayTrackingNumber(v, orderHeader?.shippingMethod)}</div>
                                                }
                                            }) :
                                            <div className="mb-2">
                                                <a onClick={() => System.popup('OrderDetailViewAllTrackingPopup', { trackingDetails: orderHeader.trackingNumbers, poNumber: orderHeader.poNumber, carrier: orderHeader?.shippingMethod })}>{t('viewAllTracking')}</a>
                                            </div>
                                        }
                                    </div> :
                                    '-'
                                }
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 border-right py-2">
                                <div className="head">{t('paymentMethod')}</div>
                                <div className="bs5 row padding0">
                                    <div className="col-sm-12 mb-2">
                                        <span className='font-13 font-arial'>
                                            {orderHeader?.paymentMethod && orderHeader?.paymentMethod.trim() !== '' ?
                                                (orderHeader?.paymentMethod?.includes('UnionPay') ? "China " + orderHeader?.paymentMethod : orderHeader?.paymentMethod)
                                                : '-'}</span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className='font-13 font-arial'><strong className="text-black">{t('termsAccountInformation')}</strong></div>
                                        <div>
                                            <div className='font-13 font-arial'>{System.getCurrentRegionWithType(apacAbbr, CORE) ? (orderHeader?.termsAccountInformation && orderHeader?.termsAccountInformation.trim() !== '' ? orderHeader?.termsAccountInformation : '-') : "-"}</div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6 pe-0">
                                        <div className='font-13 font-arial'><strong className="text-black">{t('orderTaxExemption')}</strong></div>
                                        <div>
                                            <div className='font-13 font-arial'>{orderHeader?.orderTaxExemption && orderHeader?.orderTaxExemption.trim() !== '' ? orderHeader?.orderTaxExemption : No}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-3 py-2">
                                <div className="head">{t('additionalInformation')}</div>
                                <div className="bs5 row padding0">
                                    <div className="col-sm-12 col-md-6">
                                        <div className='font-13 font-arial'><strong className="text-black">{t('orderType')}</strong></div>
                                        <div className='font-13 font-arial'>
                                            {orderHeader?.orderCreationType && orderHeader?.orderCreationType.trim() !== '' ? orderHeader?.orderCreationType : '-'}
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-lg-6">
                                        <div className='font-13 font-arial'><strong className="text-black">{t('orderDate')}</strong></div>
                                        <div className='font-13 font-arial'>
                                            {orderHeader?.orderCreationType === 'Online' ?
                                                (orderHeader.frontendOrderCreatedOn ? Helper.orderHistoryDateFormat(orderHeader.frontendOrderCreatedOn) : '-') :
                                                (orderHeader.backendOrderCreatedOn ? Helper.orderHistoryDateFormat(orderHeader.backendOrderCreatedOn) : '-')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default OrderInfoListing